import { useVisibleT } from "@/lib/cms/cms-new-i18n";
import { Checkbox } from "../ui/checkbox";
import { UseFormReturn } from "react-hook-form";
import {
  ArtworkPrintSettings,
  PrintTemplate,
  getSettingsGroups,
} from "../artwork/artworkPrintSettings";
import { ShowAllFieldsToggle } from "@/lib/print-field-presence/ShowAllFieldsToggle";
import { usePresentPrintFields } from "@/lib/print-field-presence/usePresentPrintFields";

type SelectAllCheckboxProps = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  form: UseFormReturn<any>;
  template: PrintTemplate;
};

export default function SelectAllCheckbox({ form, template }: SelectAllCheckboxProps) {
  const vt = useVisibleT();
  const { fieldsForGroup } = usePresentPrintFields();

  // « Tout cocher » ne doit porter que sur les cases réellement proposées :
  // cocher un champ masqué le ferait repartir à true dans le payload, pour un
  // champ dont on vient d'établir qu'il n'imprimera rien.
  const getAllFields = () => {
    return Object.keys(getSettingsGroups(template)).flatMap((groupKey) =>
      fieldsForGroup(template, groupKey),
    );
  };

  const allFields = getAllFields();
  const currentSettings = form.watch("settings");
  const allChecked =
    allFields.length > 0 &&
    allFields.every((field) => currentSettings[field as keyof ArtworkPrintSettings]);
  const noneChecked = allFields.every(
    (field) => !currentSettings[field as keyof ArtworkPrintSettings],
  );

  const setAllFields = (checked: boolean) => {
    const newSettings = { ...currentSettings };
    allFields.forEach((field) => {
      newSettings[field as keyof ArtworkPrintSettings] = checked;
    });
    form.setValue("settings", newSettings);
  };

  const handleCheckedChange = (checked: boolean | "indeterminate") =>
    setAllFields(!!checked);

  return (
    <div className="flex items-center justify-start gap-4 mb-4">
      <div className="flex items-center gap-2">
        <Checkbox checked={allChecked} onCheckedChange={handleCheckedChange} />
        <label
          className="text-sm font-normal cursor-pointer"
          style={{ color: "#008BD4" }}
          onClick={() => handleCheckedChange(!allChecked)}
        >
          {vt("selectAll", "Tout cocher")}
        </label>
      </div>
      {/* Retour client : decocher la case "Tout cocher" ne suffisait pas,
          il faut une action explicite pour vider la selection. */}
      <button
        type="button"
        className="text-sm font-normal underline disabled:no-underline disabled:opacity-40"
        style={{ color: "#008BD4" }}
        disabled={noneChecked}
        onClick={() => setAllFields(false)}
      >
        {vt("unselectAll", "Tout décocher")}
      </button>
      <div className="ml-auto">
        <ShowAllFieldsToggle />
      </div>
    </div>
  );
}
